import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Toaster from 'v-toaster'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'v-toaster/dist/v-toaster.css';
import Vuelidate from "vuelidate";
import VMask from "v-mask";
import store  from './store/index.js';
import CKEditor from 'ckeditor4-vue';

function loggedIn()
{
    return localStorage.getItem('token');
}

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(VMask);
Vue.use(CKEditor);
Vue.use(Toaster, {timeout: 5000});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn()) {
            return next({
                path: '/login',
            });
        } else {
            if (store.getters["currentUser/getUser"] === null) {
                await store.dispatch('currentUser/initUser');
            }

            if (to.path === '/') {
                return next();
            }

            const hasAccess = store.getters['currentUser/getUserCanRead'](to.path);

            if (!hasAccess) {
                return next({ name: 'home' });
            }

            return next();
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (loggedIn()) {
            return next({
                path: '/',
            });
        } else {
            return next();
        }
    }
});

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");

new Vue({
    router,
    render: h => h(App),
    store,
}).$mount('#app')
